import React, {
  Suspense,
  useEffect,
  useRef, useState,
} from 'react';

import { Outlet } from '@tanstack/react-router';

import Footer from '../components/Footer';
import GridPattern from '../components/GridPattern';
import Header from '../components/Header';
import Navigation from '../components/navigation/Navigation';
import classNames from '../utils/classNames';

import type { JSX } from 'react';

interface MainLayoutProps {
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps): JSX.Element => {
  const panelId = 'panel-id';

  const [expanded, setExpanded] = useState(false);

  const closeRef = useRef<React.ComponentRef<'button'>>(null);
  const openRef = useRef<React.ComponentRef<'button'>>(null);
  const navRef = useRef<React.ComponentRef<'div'>>(null);

  useEffect(() => {
    function onClick(event: MouseEvent) {
      if (
        event.target instanceof HTMLElement
        && event.target.closest('a')?.href === window.location.href
      ) {
        setExpanded(false);
      }
    }

    window.addEventListener('click', onClick);

    return () => {
      window.removeEventListener('click', onClick);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* <header> */}
      {/* Desktop Navigation */}
      {/* <div className="hidden lg:block bg-neutral-950 relative z-50">
          <div className="pt-8 pb-8">
            <Header
              invert
              showDesktopNav
              expanded={false}
              onToggle={() => { }}
              panelId={panelId}
              toggleRef={closeRef}
            />
          </div>
        </div> */}

      {/* Mobile Header */}
      {/* <div
          aria-hidden={expanded ? 'true' : 'false'}
          className="lg:hidden absolute top-2 right-0 left-0 z-40 pt-14"
          inert={!!expanded}
        >
          <Header
            expanded={expanded}
            panelId={panelId}
            toggleRef={openRef}
            onToggle={() => {
              setExpanded((exp) => !exp);
              window.setTimeout(() => closeRef.current?.focus({ preventScroll: true }));
            }}
          />
        </div> */}

      {/* Mobile Navigation Panel */}
      {/* <div
          aria-hidden={expanded ? undefined : 'true'}
          className="lg:hidden relative z-50 overflow-hidden bg-neutral-950 pt-2"
          id={panelId}
          inert={expanded ? undefined : true}
          style={{ height: expanded ? 'auto' : '0.5rem' }}
        >
          <div className="bg-neutral-800">
            <div ref={navRef} className="bg-neutral-950 pt-14 pb-16">
              <Header
                invert
                expanded={expanded}
                panelId={panelId}
                toggleRef={closeRef}
                onToggle={() => {
                  setExpanded((exp) => !exp);
                  window.setTimeout(() => openRef.current?.focus({ preventScroll: true }));
                }}
              />
            </div>
            <Navigation />
          </div>
        </div>
      </header> */}
      <div
        style={{ borderTopLeftRadius: 40, borderTopRightRadius: 40 }}
        className={classNames(
          'relative flex overflow-hidden bg-white flex-1',
          'lg:pt-0', // No top padding on desktop since nav is above
          'pt-14', // Keep top padding on mobile for hamburger header
        )}
      >
        <div
          className="relative isolate flex w-full flex-col pt-9"
        >
          {/* <GridPattern
            interactive
            yOffset={-96}
            className={classNames(
              'absolute inset-x-0 -top-14 -z-10 h-[1000px] w-full',
              'mask-[linear-gradient(to_bottom_left,white_40%,transparent_50%)]',
              'fill-neutral-50 stroke-neutral-950/5',
            )}
          /> */}

          <main className="w-full flex-auto">
            {/* <Suspense> */}
            {children ?? <Outlet />}
            {/* </Suspense> */}
          </main>

        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default MainLayout;
